import { useNavigate } from 'react-router-dom';
import { loginProps, loginWithPin } from '@/api/server/user/read';
import ArrowLinkButton from '@/component/common/arrow-link-button';
import RandomKeypad from '@/component/common/random-keypad';
import SecretNumberDisplay from '@/component/common/secret-number-display';
import SFStepper from '@/component/common/sf-stepper';
import TopBackButton from '@/component/common/top-back-button';
import { SFPalette } from '@/lib/color';
import { localGetStorage, localSetStorage, loginLocalStorage, resLoginStorageProps } from '@/lib/storage';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { toast } from 'react-toastify';
import ErrorRes from '@/api/server/ErrorRes';
import { loginCheck, pinLogin } from '@/component/users/login';
import { useAuthInfoActions } from '@/store/zustand/store';
import { updatePushToken } from '@/api/server/user/update';
import { useCacheBuster } from 'react-cache-buster';
import { keepEmail } from '@/component/users/common/keepEmail';

export default function PinSignIn() {
  const navigate = useNavigate();
  const { setAuthInfo } = useAuthInfoActions();
  const { checkCacheStatus } = useCacheBuster();

  const [secretNumber, setSecretNumber] = useState('');
  const success = async () => {
    const re: resLoginStorageProps = loginLocalStorage();
    if (!re) {
      toast.error('아이디, 비밀번호 입력 후 접근이 가능합니다.');
      return;
    }
    const payload: loginProps = {
      email: String(re.email),
      pin_pw: secretNumber,
    };
    const res = await pinLogin(payload);

    if (res.code !== 200) {
      ErrorRes({ code: res.code, msg: res.msg, path: 'pinSignIn', isBack: false });
      setSecretNumber('');
      return;
    }
    if (!res.data) {
      return;
    }
    checkCacheStatus();
    updatePushToken();
    setAuthInfo(res!.data.value);
    const email = re.email;
    keepEmail(email, false, 'pin');
    localSetStorage(res!.data);
    navigate('/wallet');
  };
  return (
    <Container maxWidth="sm">
      <TopBackButton title="PIN 번호 로그인" />
      <Box pt={4}>
        <Typography variant="h4" mb={2.5}>
          <b>
            PIN번호 <br />
            6자리
          </b>
          를 입력해 주세요.
        </Typography>
        {/* <Box mb={5}>
          <ArrowLinkButton onClick={() => {}}>혹시 PIN 번호를 잊어버리셨나요?</ArrowLinkButton>
        </Box> */}

        <Box mb={5}>
          <SecretNumberDisplay value={secretNumber} />
        </Box>
        {/* <Box position="absolute" bottom={0} left={0} mb={2}> */}
        <Box position="sticky" bottom={0}>
          <RandomKeypad
            value={secretNumber}
            onChange={setSecretNumber}
            onSuccess={async () => {
              await success();
            }}
          />
          {/* <Box mt={4.25} textAlign="center" pb={5}>
            <ArrowLinkButton onClick={() => {}}>
              다른 방법으로 로그인 하기
            </ArrowLinkButton>
          </Box> */}
        </Box>
      </Box>
      {/* </Box> */}
    </Container>
  );
}
